import { Button } from '@companycam/slab-web';
import styled from 'styled-components';

export const BackIcon = styled.i.attrs({
  className: 'mdi mdi-chevron-left', // Automatically applies the class
})`
  font-size: calc(calc(var(--cc_size_text_s) + 1px) + 4px);
  margin-right: var(--cc_size_spacing_xs);
`;

export const CreateButton = styled(Button)`
  @media screen and (min-width: 800px) {
    && {
      margin: -84px 0 var(--cc_size_spacing_xxl) auto;
    }
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
